import { MoveStationSaveStatus } from "../../../interfaces/robot/rooms/hub-messages/receive-move-station-command-message";
import ZoneControllerMouseState from "../../../enums/robot/zone-planner/zone-controller-mouse-state";
import ZonePlannerModeState from "../../../enums/robot/zone-planner/zone-planner-mode-state";
import { StationDrag } from "../../../interfaces/robot/rooms/station";
import Point from "../../../interfaces/robot/rooms/point";
import IMapCrop from "../../../interfaces/robot/zone-planner/map-crop";
import MapHistoryEntry from "../../../interfaces/robot/zone-planner/map-history";
import TeachingUpdateMessage from "../../../interfaces/robot/rooms/hub-messages/teaching-update-message";
import RestSet, { defaultRestSet } from "../../../interfaces/api/rest-set";

interface ZonePlannerState {
  plannerMode: ZonePlannerModeState;
  mouseMode: ZoneControllerMouseState;

  generatingTeachPathMessage: TeachingUpdateMessage | null;
  isGeneratingTeachPath: boolean;

  zoneIdsSentToBackOrder: string[];
  hiddenZoneIds: string[];
  hiddenLandmarkIds: string[];
  hiddenGateIds: string[];

  chargingStationDrag: StationDrag;

  currentTeachingAutoZonePath: {
    zoneId: string | null;
    selectedTeachAndRepeatPathPointId: string | null;
  };

  selectedZone: {
    id: string | null;
    selectedPointId: string | null;
    prevDragPoint: Point | null;
  };

  history: {
    undo: MapHistoryEntry[];
    redo: MapHistoryEntry[];
  };
}

export default ZonePlannerState;

export const defaultZonePlannerState: ZonePlannerState = {
  plannerMode: ZonePlannerModeState.Default,
  mouseMode: ZoneControllerMouseState.Default,

  generatingTeachPathMessage: null,
  isGeneratingTeachPath: false,

  zoneIdsSentToBackOrder: [],
  hiddenZoneIds: [],
  hiddenLandmarkIds: [],
  hiddenGateIds: [],

  chargingStationDrag: {
    isDragging: false,
    isSelected: false,
    error: null,
    saveStatus: MoveStationSaveStatus.Idle,
    unsavedChanges: false,
  },

  currentTeachingAutoZonePath: {
    zoneId: null,
    selectedTeachAndRepeatPathPointId: null,
  },

  selectedZone: {
    id: null,
    selectedPointId: null,
    prevDragPoint: null,
    // cleaningZoneOriginalNavigator: null,
  },
  history: {
    undo: [],
    redo: [],
  },
};
